import SelectComponentTypePopup from "./SelectComponentTypePopup";
import { jsx as _jsx } from "react/jsx-runtime";
export default function initializeSelectComponentType(selectableModules, callback) {
  var popupEvent = new CustomEvent("openPopup", {
    detail: {
      C: function C() {
        return /*#__PURE__*/_jsx(SelectComponentTypePopup, {
          selectableModules: selectableModules,
          callback: callback
        });
      }
    }
  });
  window.dispatchEvent(popupEvent);
}